/** A reconciliation continuation repeats the list query; only the final snapshot is published. */
export interface NotificationSnapshot<T> {notifications:T[];unreadCount:number|null}
export async function fetchNotificationSnapshot<T>(
  url:string,
  request:(url:string)=>Promise<Response>,
  isCurrent:()=>boolean=()=>true,
):Promise<NotificationSnapshot<T>> {
  const seen=new Set<string>();
  let cursor:string|undefined;
  for(let page=0;page<100;page++) {
    if(!isCurrent())throw new Error('Notification scope changed.');
    const next=new URL(url);
    if(cursor)next.searchParams.set('readSyncCursor',cursor);
    const response=await request(next.toString());
    if(!isCurrent())throw new Error('Notification scope changed.');
    if(!response.ok)throw new Error(`Notifications unavailable (${response.status}).`);
    const data=await response.json();
    if(!isCurrent())throw new Error('Notification scope changed.');
    if(data.success===false||!Array.isArray(data.notifications))throw new Error('Notification list could not be confirmed.');
    const count=data.unreadCount;
    if(count!==undefined&&(!Number.isSafeInteger(count)||count<0))throw new Error('Unread count could not be confirmed.');
    const after=data.readSync?.nextCursor;
    if(data.readSync?.complete===false) {
      if(typeof after!=='string'||!after.length||after.length>512||/[\x00-\x1f\x7f]/.test(after)||seen.has(after))throw new Error('Notification continuation could not be confirmed.');
      seen.add(after);cursor=after;continue;
    }
    return {notifications:data.notifications,unreadCount:count??null};
  }
  throw new Error('Notification reconciliation exceeded its request limit.');
}
